import React from 'react'
import { Button, Image, Modal } from 'semantic-ui-react'

import { Icon } from 'semantic-ui-react'
import './modal.css';

import qrcode from '../../assets/images/qrcode.JPG'

function ModalExampleContentImage() {
  const [open, setOpen] = React.useState(false)
// TODO: finir le modal, plus petit, le rajouter pour snap 
  return (
    <Modal
      className="contentSnap"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button className="ui_snap animate__animated animate__bounce"><Icon  name='snapchat ghost' size='huge' /></Button>}
    >
      <Modal.Content image>
        <Image className="imageSnap" size='medium' src={qrcode} wrapped />
        {/* <Modal.Description>
          <p>Would you like to upload this image?</p>
        </Modal.Description> */}
      </Modal.Content>
    </Modal>
  )
}

export default ModalExampleContentImage
